var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"primary":"","small":""},on:{"click":_vm.showUploadAssetsDialog}},[_vm._v(" Upload Assets ")])
}
var staticRenderFns = []

export { render, staticRenderFns }